<template>
  <div id="title-bar">
    <div class="left">
      <img src="/icon-generic.ico" alt="logo">
      <div>
        <strong>Film Lab Assistant</strong>
      </div>

    </div>

    <div class="right">

      <LoginPersonVue
        :loginCb="loginCb"
        :labOrdersUpdateCb="updateOrdersCb"
      />

      <div 
        v-if="!onHomePage"
        class="clickable home"
        @click="goToPage('/')"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-house" viewBox="0 0 16 16">
          <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293zM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5z"/>
        </svg>
      </div>
    </div>

  </div>

</template>


<script>

import router from '../../router/index.js';
import LoginPersonVue from './LoginPerson.vue';


// GLOBALS
// ----------------

// ----------------


export default {
  name:'UserBar',
  components: {
    LoginPersonVue,
  },
  props:{
    loginCb: Function,
    updateOrdersCb: Function,
  },
  data() {
    return {
      showIconModal: false,
    }
  },
  computed: {
    onHomePage() {
      const { pathname } = window.location;
      return pathname === '/';
    }
  },
  methods: {
    goToPage( path ) {
      router.push(path);
    }
  },
  mounted(){}
}
</script>


<style scoped>

#title-bar {
  display: flex;
  justify-content: space-between;
  padding: .5rem;
  border-bottom: 1px solid black;
  /* margin is stored in global CSS  */
}




.clickable {
  cursor: pointer;
  border-radius: 10px;
  padding: .5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 .5rem;
  transition: all .3s;
}

.right, .left {
  flex-direction: row;
  display: flex;
  align-items: center;
}

.left img {
  height: 2rem
}

.clickable:hover {
  background-color: blanchedalmond;
  background-color: var(--fla-gray);
}

.account { position: relative; }

/* #icon-modal {
  transition: max-height 0.3s ease-in-out;
  background-color: blue;
  position: absolute;
  display: flex;
  top: 2.25rem;
  right: 0;
  min-height: 1rem;
  max-height: 0;
  overflow: hidden;
}

.account:hover #icon-modal {
  max-height: 10rem;
} */

#icon-modal {
  background-color: rgb(145, 145, 203);
  position: absolute;
  top: 2.25rem;
  right: 0;
  overflow: hidden;
  /* height: 0; */
  width: 10rem;
  opacity: 0;
  transition: height 0.3s ease, opacity 0.3s ease;
}

#icon-modal.show {
  height: 5rem;
  opacity: 1;
}

#icon-modal.hide {
  height: 0;
  opacity: 0;
}


</style>